import {CategoriesAPI} from "../api/CategoriesAPI";
import {AppStore} from "../desktop";
import {actionCategoryFetchAllCompleted, actionCategoryFetchCompleted} from "../store/categories/actions";
import {BaseService} from "./BaseService";
import {Category} from "../models/Category";
import {CategoriesActionTypes} from "../store/categories";
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {actionToastrInfo} from "../store/global";

export default class CategoriesService extends BaseService {

	static getAll() {

        let categoriesAPI: CategoriesAPI = new CategoriesAPI()

		categoriesAPI.getAll().then(CategoriesService.processResponse)
		.then((result) => actionCategoryFetchAllCompleted(CategoriesService.fromAPIList(result)))
		.catch(error => ErrorService.handleError(error))
	}

    static getOne(category: Category) {

        let categoriesAPI: CategoriesAPI = new CategoriesAPI()

        categoriesAPI.get(category).then(CategoriesService.processResponse).then(result => {
			actionCategoryFetchCompleted(CategoriesService.fromAPIItem(result))
        }).catch(error => ErrorService.handleError(error))

    }

    static save(category: Category) {

        let categoriesAPI: CategoriesAPI = new CategoriesAPI()

		if (category.id) {
			categoriesAPI.put(CategoriesService.itemToRequest(category)).then(CategoriesService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: CategoriesActionTypes.SAVE_COMPLETED, payload: CategoriesService.fromAPIItem(data)
					})
					actionToastrInfo("Info", "Kategorija je uspešno snimljena")
					actionSetTabStateItem(CategoriesService.fromAPIItem(data))
					actionSetTabItem(CategoriesService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			categoriesAPI.post(CategoriesService.itemToRequest(category)).then(CategoriesService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: CategoriesActionTypes.SAVE_COMPLETED, payload: CategoriesService.fromAPIItem(data)
					})
					actionToastrInfo("Info", "Kategorija je uspešno snimljena")
					actionSetTabStateItem(CategoriesService.fromAPIItem(data))
					actionSetTabItem(CategoriesService.fromAPIItem(data))
				}
			).catch(error => ErrorService.handleError(error))

		}

	}

	static delete(category: Category) {

        let categoriesAPI: CategoriesAPI = new CategoriesAPI()

		categoriesAPI.delete(CategoriesService.itemToRequest(category)).then(CategoriesService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: CategoriesActionTypes.DELETE_COMPLETED, payload: category
				})
				actionDeleteTabForItemId(category.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteMultiple(categories: Category[]) {

		let categoriesAPI: CategoriesAPI = new CategoriesAPI()
		let count = 0;
		categories.forEach(category => {

			categoriesAPI.delete(CategoriesService.itemToRequest(category)).then(CategoriesService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(category.id)
					if(count === categories.length)
						AppStore.dispatch({
							type: CategoriesActionTypes.DELETE_MULTIPLE_COMPLETED, payload: categories
						})
				}
			).catch(error => ErrorService.handleError(error))
		});

	}

    static fromAPIList(apiList: any): Category[] {
        const localList = apiList.map((apiItem: any) => CategoriesService.fromAPIItem(apiItem));
        //console.info('[fromAPICategoryList] converted categories: ', localList);
        return localList;
    }

    static fromAPIItem(apiItem: any): Category{
        let category = new Category();

        category.id = apiItem.id;
        category.title = apiItem.name;
		category.description = apiItem.description;

        return category;
    }

    static itemToRequest (category: Category): any {

		let itemRequest: any = {};

		if(category.id)
        itemRequest.id = category.id;

		itemRequest.name = category.title;
		itemRequest.description = category.description;

		return itemRequest
	}

	static responseToItems (data: any) {
		return data
	}
}
